<template>
  <div v-if="scheduleTime">
    <strong>ส่งข้อความตามไปในเวลา</strong>
    <template v-if="scheduleTime.HH != '00'">{{ scheduleTime.HH }} ชั่วโมง</template>
    <template v-if="scheduleTime.mm != '00'">{{ scheduleTime.mm }} นาที</template>
  </div>
</template>

<script>
export default {
  props: ['value'],
  computed: {
    scheduleTime: function () {
      try {
        if (this.value) {
          if (this.value.is_followup_schedule && this.value.followup_schedule_time) {
            const scheduleTime = parseInt(this.value.followup_schedule_time)
            const time = scheduleTime / 60
            const hour = Math.trunc(time) || 0
            const hourFormat = hour.toString().padStart(2, '0')
            let minutes = scheduleTime - hour * 60
            const minuteFormat = minutes.toString().padStart(2, '0')
            return { HH: hourFormat, mm: minuteFormat }
          }
        }
        return false
      } catch (error) {
        console.error(error)
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/generalixwarroom/FollowupMessageScheduleDetail.vue